import React from 'react';
import { makeAutoObservable } from 'mobx';
import { observer } from 'mobx-react';
import { Text } from '@fluentui/react';
import API, { IUserConfigPackage } from '../../API';

const STORAGE_KEY = 'userWelcome_givenName';

export class UserWelcomeState {
	public userConfig: IUserConfigPackage;
	public givenName: string = localStorage.getItem(STORAGE_KEY) ?? '';

	public constructor(userConfig: IUserConfigPackage) {
		makeAutoObservable(this);
		this.userConfig = userConfig;
	}

	public async ensureLoaded() {
		const token = await this.userConfig.getToken();
		const api = new API(token);
		const info = await api.getCurrentUserInfo();
		this.givenName = info.givenName;
		localStorage.setItem(STORAGE_KEY, info.givenName);
	}

	public get greeting(): string {
		const hour = new Date().getHours();
		if (hour < 12) return 'Good morning';
		if (hour < 18) return 'Good afternoon';
		return 'Good evening';
	}

	public get formattedDate(): string {
		return new Intl.DateTimeFormat(navigator.language, {
			weekday: 'long',
			year: 'numeric',
			month: 'long',
			day: 'numeric',
		}).format(new Date());
	}
}

export interface IUserWelcomeProps {
	state: UserWelcomeState;
}

class UserWelcome extends React.Component<IUserWelcomeProps> {

	componentDidMount() {
		this.props.state.ensureLoaded();
	}

	render() {
		const { greeting, givenName, formattedDate } = this.props.state;

		return (
			<div>
				<Text variant="xLarge" block styles={{ root: { fontWeight: 600 } }}>
					{greeting}{givenName ? `, ${givenName}` : ''}
				</Text>
				<Text variant="medium" block styles={{ root: { color: '#605e5c', marginTop: 4 } }}>
					{formattedDate}
				</Text>
			</div>
		);
	}
}

export default observer(UserWelcome);
